import { render } from "./plateCreate.vue?vue&type=template&id=6a235d52"
import script from "./plateCreate.vue?vue&type=script&lang=js"
export * from "./plateCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__